'use client';
import { getImageSource } from '@lib/tools/_get_image_source';
import { useViewport } from '@lib/tools/hooks/useViewport';
import { animated, useSpring } from '@react-spring/web';
import cn from 'classnames';
import NextImage from 'next/image';

import style from './BackgroundImage.module.scss';

const BackgroundImage = ({
  first,
  toggle,
  className,
  name,
  src,
  src375,
  imagePlug,
  loading = 'lazy',
  decoding = 'async',
  priority = false,
  fetchPriority = 'auto',
}) => {
  const { isMobile } = useViewport();

  const mainSrc = getImageSource(src);
  const mobSrc = getImageSource(src375);
  const plugSrc = getImageSource(imagePlug);

  const scaleStyle = useSpring({
    config: {
      duration: 2050,
      mass: 1,
      tension: 280,
      friction: 120,
    },
    delay: 10,
    scaleY: !toggle ? 1.5 : 1,
    scaleX: !toggle ? 1.5 : 1,
  });

  const mobileCurrentSrc = mobSrc || plugSrc;
  const desktopCurrentSrc = mainSrc || plugSrc;

  const currentSrc = isMobile ? mobileCurrentSrc : desktopCurrentSrc;

  return (
    <>
      {first && (
        <animated.div style={scaleStyle} className={cn(style.backgroundContainer, className)}>
          <NextImage
            fill
            style={{
              backgroundSize: 'cover',
              backgroundImage: plugSrc ? `url(${plugSrc})` : 'none',
            }}
            loading={loading}
            fetchPriority={fetchPriority}
            priority={priority}
            decoding={decoding}
            src={currentSrc}
            alt={name || 'background image'}
          />
        </animated.div>
      )}
      {!first && (
        <div
          className={cn(style.backgroundContainer, className)}
          style={{
            backgroundSize: 'cover',
            backgroundImage: plugSrc ? `url(${plugSrc})` : 'none',
          }}
        >
          <NextImage
            width={src?.width}
            height={src?.height}
            style={{
              backgroundSize: 'cover',
              backgroundImage: plugSrc ? `url(${plugSrc})` : 'none',
              width: '100%',
              height: 'auto',
            }}
            loading='lazy'
            decoding='async'
            src={currentSrc}
            alt={name || 'background image'}
          />
        </div>
      )}
    </>
  );
};

export default BackgroundImage;
